import { Skeleton } from '@mui/material';

import clsx from 'clsx';

import ToolbarSkeleton from '../Toolbar/skeleton';
import { richTextEditorClasses, Root } from './styles';
import { EditorProps } from './types';

export interface EditorSkeletonProps extends Pick<EditorProps, 'toolbar' | 'children' | 'className' | 'classes'> {}

const EditorSkeleton = ({
  toolbar = {
    canFormatText: true,
    canInsertFormula: true,
    canUploadImage: true,
  },
  children,
  className,
  classes,
}: EditorSkeletonProps) => {
  return (
    <Root className={clsx(classes?.root, className)}>
      <Skeleton
        variant="rectangular"
        width="100%"
        height="100%"
        className={clsx(richTextEditorClasses.body, classes?.body)}
      >
        {children}
      </Skeleton>
      {toolbar !== false && (
        <ToolbarSkeleton
          {...toolbar}
          className={classes?.toolbar}
          classes={{
            ...classes,
            root: classes?.toolbar,
          }}
        />
      )}
    </Root>
  );
};

export default EditorSkeleton;
